import { Component, OnInit, Inject,AfterViewInit } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { LeadsService } from 'src/app/_service/leads.service';
import { SharedService } from '../../_service/shared.service';
@Component({
  selector: 'app-follow-dnp-detail-modal',
  templateUrl: './follow-dnp-detail-modal.component.html',
  styleUrls: ['./follow-dnp-detail-modal.component.css']
})
export class FollowDnpDetailModalComponent implements OnInit {
  modalData:any; leadDnpFollowDetail=[]; message: string='ravi maurya';
  constructor(private leadapi: LeadsService,public sharedapi:SharedService,public dialogRef: MatDialogRef<FollowDnpDetailModalComponent>,@Inject(MAT_DIALOG_DATA) public data: MatDialog) {
    if(data){
      this.modalData = data;
      this.showDNPFollowDetail();
    }
  }

  ngOnInit(): void {
  }

  CloseModal(): void {
    this.dialogRef.close();
  }
  showDNPFollowDetail(){
    this.leadapi.showDNPFollow_Detail(this.modalData.leadId).subscribe((data:any) => {
        if(data.status)
        {
            this.leadDnpFollowDetail = data.result;
        }
    }, error => {
         this.sharedapi.checkError(error);
    });
}

}
